import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { UserRight } from "@biteinc/enums";
//#region src/utils/user_utils.ts
var user_utils_exports = /* @__PURE__ */ __exportAll({
	canManageRightsInOrg: () => canManageRightsInOrg,
	firstLastNameOrUsername: () => firstLastNameOrUsername,
	getMembership: () => getMembership,
	getOrgMembership: () => getOrgMembership,
	getRights: () => getRights,
	hasRight: () => hasRight,
	isApiTokenMembership: () => isApiTokenMembership,
	isBite: () => isBite,
	isFlash: () => isFlash,
	isKiosk: () => isKiosk
});
/**
* Display name: "First Last" when either name part is set, otherwise the username.
* Not the same as `User.displayName()`, which returns the username alone.
*/
function firstLastNameOrUsername(data) {
	if (data.firstName || data.lastName) return `${data.firstName || ""} ${data.lastName || ""}`.trim();
	return data.username ?? "";
}
function isBite(data) {
	return !!data.biteMembership;
}
function isFlash(data) {
	return !!(data.orgMemberships ?? []).at(0)?.rights.includes(UserRight.FlashRight);
}
function isKiosk(data) {
	return !!(data.orgMemberships ?? []).at(0)?.rights.includes(UserRight.KioskRight);
}
function isApiTokenMembership(membership) {
	return membership.rights.includes(UserRight.ApiToken);
}
function isOrgMembership(membership) {
	return "orgId" in membership;
}
function getMembership(data, orgId) {
	if (isBite(data)) return data.biteMembership;
	if (!orgId) return;
	return data.orgMemberships?.find((membership) => membership.orgId.toString() === orgId.toString());
}
function getOrgMembership(data, orgId) {
	const membership = getMembership(data, orgId);
	return membership && isOrgMembership(membership) ? membership : void 0;
}
/** Get all rights a user holds in an org context. Empty when there is no membership. */
function getRights(data, orgId) {
	return getMembership(data, orgId)?.rights ?? [];
}
/** Check if a user holds a specific right in an org context. No implicit BiteAdmin grant. */
function hasRight(data, right, orgId) {
	return getRights(data, orgId).includes(right);
}
/**
* Check if a user may grant or manage the given set of rights, optionally in the context of a
* specific org. When `orgId` is set, the user must belong to that org or be a bite user.
*
* The early-return ladder (BiteAdmin → ManageLowerBiteUsers → BiteAccess → Admin →
* ManageLowerUsers) is load-bearing: `hasRight` has no implicit BiteAdmin grant, so each tier
* must be checked explicitly and in this order. `getMembership` does not filter disabled
* memberships, by design.
*/
function canManageRightsInOrg(data, rights, orgId) {
	if (rights.includes(UserRight.FlashRight) || rights.includes(UserRight.KioskRight)) return false;
	if (getMembership(data, orgId) === void 0) return false;
	if (hasRight(data, UserRight.BiteAdmin, orgId)) return true;
	if (hasRight(data, UserRight.ManageLowerBiteUsers, orgId)) return !rights.includes(UserRight.ManageLowerBiteUsers);
	if (hasRight(data, UserRight.BiteAccess, orgId)) return !rights.includes(UserRight.BiteAccess);
	if (hasRight(data, UserRight.Admin, orgId)) return !rights.includes(UserRight.BiteAccess) && rights.every((right) => hasRight(data, right, orgId));
	if (hasRight(data, UserRight.ManageLowerUsers, orgId)) {
		if (rights.includes(UserRight.ManageLowerUsers)) return false;
		return rights.every((right) => hasRight(data, right, orgId));
	}
	return false;
}
//#endregion
export { canManageRightsInOrg, firstLastNameOrUsername, getMembership, getOrgMembership, getRights, hasRight, isApiTokenMembership, isBite, isFlash, isKiosk, user_utils_exports };

//# sourceMappingURL=user_utils.js.map